/* eslint-disable @typescript-eslint/no-explicit-any */
import CompoTitle from "@/pages/_common/CompoTitle";
import axios from "axios";
import { useEffect, useState } from "react";
import GameListView from "./GameListView";
import CTL_Button from "@/compo/CTL_Button";


export default function GameList(){

  const [gameData, set_gameData] = useState({
    list:[],
    count:0
  });

  useEffect(() => {    
    async function _getGameList() {
      const { data } = await axios.post("/game/listup");
      set_gameData({...data})
    }
    _getGameList();
  }, []);

  async function _createGame(){
    const { data } = await axios.post("/game/create",{});
    set_gameData({...data})
  }
  return <div className="px-3">
    {/* 새글등록 */}
    <CTL_Button className="w-full" onClick={() => _createGame()}>
      <div>새 대회 생성</div>
    </CTL_Button>

    {/* 대회 목록 출력 */}
    <CompoTitle>
      <div className="flex items-center">
        <div className="flex-1">대회 목록</div>
        <div className="text-[.8rem] text-zinc-500 font-normal self-end">
          총 {gameData.count}개의 등록된 대회가 있습니다.
        </div>
      </div>
    </CompoTitle>

    <GameListView
      data={gameData.list}
      className="px-2"
      onUpdate={(tournamentData:any)=>set_gameData({...tournamentData})}
    />
    <div className="border-b border-zinc-300" />
  </div>
}